<script lang="ts">
  import { isShowLoader, categories } from '../../store'
  import { _ } from 'svelte-i18n'
  import NoItemsBanner from '../../../../custom/NoItemsBanner.svelte'
</script>

{#if !$isShowLoader && !$categories.length}
  <NoItemsBanner 
    title="{$_('nothingToSeeHere')}"
    subtitle="{$_('contentComingSoon')}"
    background="/static/no-items.jpeg" 
  />
{/if}